import { Field as RffField, FieldRenderProps } from 'react-final-form';
import { RffFieldProps } from './FieldProps';
import * as React from 'react';
import { PropsWithChildren, ReactNode } from 'react';

export const Field = <
  FieldValue = any,
  T extends HTMLElement = HTMLElement,
  InputValue = FieldValue,
>(
  props: Omit<PropsWithChildren<RffFieldProps>, 'children'> & {
    children:
      | ReactNode
      | ((props: FieldRenderProps<FieldValue, T, InputValue>) => ReactNode);
  }
) => {
  const { children, ...restProps } = props;
  return (
    <RffField<FieldValue, T, InputValue> {...restProps}>
      {
        // @ts-ignore
        children
      }
    </RffField>
  );
};

export default Field;
